import { createFetchContext } from '@/modules/auto-fetch-contex'
import { messageMediaService } from '@/modules/message/service/message-media-service'

export const { useMessageMediaService, DefaultMessageMediaProvider } =
  createFetchContext('MessageMedia', {
    messageMediaService,
  })
